import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { Elements, StripeProvider } from 'react-stripe-elements';

import facility from 'app/facility';
import { getLocale } from 'common/utils';
import form from 'modules/ticketPublicPage/stores/vouchers/form';
import { WarningNote } from 'modules/ticketPublicPage/components/tickets/styles/_details';
import { TicketInlineAlerts } from 'modules/ticketPublicPage/components/common/_inlineAlert';

import config from '../../config';

import PaymentOptions from '../common/_paymentOptions';
import NewsletterCheckbox from '../common/_newsletterCheckbox';
import { CheckboxContainer } from '../common/styles';

import {
  GreetingMessage,
  VoucherCheckoutContainer,
  VoucherRecipientInfo,
} from './styles/_paymentDetails';

const {
  settings: { stripePublishKey },
} = facility;

const PaymentDetails = observer(() => {
  const { formValues, serverError, setFormValue } = form;
  const price = formValues.get('price').toString().replace(',', '.');
  return (
    <Fragment>
      <VoucherCheckoutContainer>
        <VoucherRecipientInfo>
          <div>
            <span style={{ fontSize: '0.8rem' }}>{i18n.gettext('To:')}</span>
            <span>{formValues.get('recipient')}</span>
          </div>
          <div>
            <span style={{ fontSize: '0.8rem' }}>{i18n.gettext('From:')}</span>
            <span>{formValues.get('sender')}</span>
          </div>
        </VoucherRecipientInfo>
        {formValues.get('greeting_message') && (
          <div>
            <span style={{ fontStyle: 'italic', fontSize: '0.8rem' }}>
              {i18n.gettext('Greeting message')}
            </span>
            <GreetingMessage>
              {formValues.get('greeting_message')}
            </GreetingMessage>
          </div>
        )}
      </VoucherCheckoutContainer>
      <div style={{ marginTop: '1.4rem' }}>
        {stripePublishKey ? (
          <StripeProvider apiKey={stripePublishKey}>
            <Elements locale={getLocale(config.language_code)}>
              <PaymentOptions
                form={form}
                price={Number(price)}
                payPalDirectBuy
              />
            </Elements>
          </StripeProvider>
        ) : (
          <PaymentOptions form={form} price={Number(price)} payPalDirectBuy />
        )}
      </div>
      <CheckboxContainer
        style={{
          paddingTop: '3.5rem',
          paddingBottom: !serverError ? '1rem' : '0',
        }}
      >
        <NewsletterCheckbox
          checked={formValues.get('newsletter_subscribe')}
          onChange={(checked) => setFormValue('newsletter_subscribe', checked)}
        />
      </CheckboxContainer>
      {serverError && (
        <WarningNote>
          <TicketInlineAlerts errors={[serverError]} />
        </WarningNote>
      )}
    </Fragment>
  );
});

export default PaymentDetails;
